import React from "react";
import { Routes, Route } from "react-router-dom";
import Profile from "../Profile";
import FileUpload from "../Books/FileUpload";
import Books from "../Books";
import AboutDogs from "../AboutDogs/AboutDogs";
import Home from "../Home";
import Users from "../Users/Users.tsx";
import ArtGallery from "../ArtGallery/ArtGallery";
import ArtUpload from "../ArtGallery/ArtUpload";

const RoutesContainer = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/art-gallery" element={<ArtGallery />} />
      <Route path="/art-gallery/upload" element={<ArtUpload />} />
      <Route path="/library" element={<Books />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/upload" element={<FileUpload />} />
      <Route path="/sign-in" element={<Profile />} />
      <Route path="/about-dogs" element={<AboutDogs />} />
      <Route path="/users" element={<Users />} />
      <Route path="/profile/:userId" element={<Profile />} />
    </Routes>
  );
};

export default RoutesContainer;
